<template>
    <div class="topbar-container">
        <div class="top shadow-bg">
            <van-button @click="go('CarGoodsQuery',{isHome:false})" class="btn btn-query">
                <div class="bh bbetween">
                    <span>{{queryText}}</span>
                    <div class="btn-ico-el ico-query queryIco"></div>
                </div>
            </van-button>
            <div class="bh bc btn-group">
                <FoldButton
                    ref="typeCombo"
                    :text="classifyText"
                    class="b1 bh bc"
                    :selectClass="typeClass"
                    @activateChange="onActivateChange"
                ></FoldButton>
                <StateButton
                    ref="sortedByPrice"
                    text="价格"
                    class="b1 bh bc"
                    @activateChange="onSortChange($event,'sortedByPrice','sortedBySale')"
                ></StateButton>
                <StateButton
                    ref="sortedBySale"
                    text="销量"
                    class="b1 bh bc"
                    @activateChange="onSortChange($event,'sortedBySale','sortedByPrice')"
                ></StateButton>
            </div>
        </div>
        <div class="shop-container">
            <div class="bh container side-panel" :class="[isQuery?'zIndex':'']">
                <!--分类列表-->
                <div class="menu-panel" ref="menuScroll">
                    <div>
                        <div
                            class="menu-item bh bs bstart fz_30"
                            :class="{'activate':activateIndex === index}"
                            v-for="(item,index) in classifyList"
                            :key="index"
                            @click="selectMenu(index)"
                        >{{item.name}}</div>
                    </div>
                </div>

                <!--具体分类-->
                <div class="list-panel b1" ref="listScroll">
                    <div>
                        <!-- 具体分类 -->
                        <div v-for="(item,index) in classifyList" :key="index" class="big-list">
                            <div class="title fz_34">{{item.name}}</div>
                            <div
                                v-for="(item,index) in item.children"
                                :key="index"
                                @click="onQueryTypeChange(item)"
                                class="list-item list-item-inline"
                            >
                                <div class="item shadow-bg">
                                    <div
                                        class="img bg-100"
                                        :style="{backgroundImage: 'url(' + item.iconPic + ')'}"
                                    ></div>
                                    <div class="content fz_24 overflow tc">{{item.name}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="big-list"></div>
                        <div class="big-list bh bc more-panel">
                            <div class="fz_24 c_999 message">更多商品敬请期待~</div>
                        </div>
                    </div>
                </div>
            </div>
            <zbList
                v-model="store"
                :minLen="6"
                :isKeep="true"
                :isCustom="true"
                class="container shop list"
            >
                <CarGoods :data="store.data" :isGoodHome="true"></CarGoods>
            </zbList>
            <!-- 购物车按钮 -->
            <div class="float-container radius bh bc">
                <van-button class="btn btn-text" @click="go('CartHome')">
                    <div class="btn-ico-el ico-buy"></div>
                    <div v-if="cartCount" class="redNum">{{cartCount}}</div>
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
import StateButton from "@/components/btn/State";
import FoldButton from "@/components/btn/Fold";
import CarGoods from "@/views/car/goods/Item";
import { goodList } from "@/api/car";
import { mixinClassify } from "@/mixin/classify";
import { list } from "@/mixin/list";
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
import util from "@/utils/index";
import zbList from "@/components/data/List";
export default {
    mixins: [mixinClassify, list, routeCache, user],
    name: "CarGoodsHome",
    components: { zbList, StateButton, FoldButton, CarGoods },
    data() {
        return {
            goodsCategoryId: "",
            // 是否弹出分类
            isQuery: false,
            classifyText: "综合",
            // 搜索条件
            queryText: "优质商品都在这",
            // 车主用品
            store: {
                proxy: {
                    getList: goodList
                }
            }
        };
    },
    computed: {
        cartCount() {
            return this.$store.getters["cart/cartCount"];
        },
        queryParams() {
            return this.$store.state.queryParams;
        },
        typeClass() {
            // console.log(this.goodsCategoryId ? "select" : "");
            return this.goodsCategoryId ? "select" : "";
        }
    },
    watch: {
        queryParams(v) {
            this.loadData(v);
        }
    },
    created() {
        const me = this;
        // 界面初始化时查询
        if (me.queryParams) {
            me.loadData(me.queryParams);
        } else {
            me.storeLoad();
        }
    },
    beforeRouteLeave(to, from, next) {
        const me = this;
        // 隐藏查询弹窗
        me.$refs.typeCombo.reset();
        // 如果目标页面是首页，清除查询条件
        if (to.name == "ShopHome") {
            me.$store.state.queryParams = null;
        }
        next();
    },
    methods: {
        userLoginend() {
            this.$store.dispatch("cart/cartList");
        },
        loadData(params) {
            const me = this;
            if (params) {
                // 如果是字符串
                if (util.isString(params)) {
                    me.resetAll("综合", params);
                    me.storeLoad({
                        keyWord: params
                    });
                } else {
                    // 如果是对象
                    me.onQueryTypeChange(params);
                }
            }
        },
        // 重置所有查询条件
        resetAll(classifyText, queryText) {
            const me = this,
                refs = me.$refs;
            if (refs && refs.sortedByPrice) {
                // 重置查询功能
                refs.sortedByPrice.reset();
                refs.sortedBySale.reset();
                refs.typeCombo.reset();
            }
            // 重置显示状态
            me.classifyText = classifyText;
            me.queryText = queryText;
            me.isQuery = false;
        },
        // 当查询分类变化时
        onQueryTypeChange(item) {
            // 加载数据
            const me = this,
                params = {
                    goodsCategoryId: item.id,
                    name: item.name
                };
            me.goodsCategoryId = item.id;
            me.resetAll(item.name, "");
            // 重置查询功能
            me.storeLoad(params);
            me.$store.state.queryParams = null;
        },
        // 当排序改变时
        onSortChange(v, name, otherName) {
            const me = this,
                params = me.store.proxy.params || {};
            // 设置排序条件
            params[name] = v ? "asc" : "desc";
            // 将另外的排序条件置空
            params[otherName] = "";
            // 重置另外的排序控件
            me.$refs[otherName].reset();
            me.$refs.typeCombo.reset();
            me.isQuery = false;
            // 加载数据
            me.storeLoad(params);
        },
        onActivateChange(v) {
            this.isQuery = v;
        }
    }
};
</script>

<style scoped lang="scss">
/deep/.select {
    color: #fd8603;
}
/deep/ .pullup-wrapper {
    color: #666;
    padding: 60px 0;
}
.top {
    height: 192px;
    border-top: 1px solid #e5e5e5;
    text-align: center;
    .btn-query {
        margin-top: 24px;
        width: 690px;
        height: 68px;
        .queryIco{
            height: 36px;
            width: 36px;
        }
    }
    .btn-group {
        margin-top: 20px;
    }
}
.shop-container {
    height: calc(100% - 194px);
    width: 100%;
    position: relative;
    .container {
        position: absolute;
    }
    .side-panel {
        height: calc(100% - 10px);
        width: 100%;
        z-index: 0;
        background-color: #fff;
        margin-top: 10px;
    }
    .shop {
        z-index: 1;
        width: calc(100% - 40px);
        height: calc(100% - 20px);
        padding: 10px 20px;
        background-color: #f1f2f3;
    }
    .zIndex {
        z-index: 4;
    }
}
.float-container {
    width: 82px;
    height: 82px;
    .van-button--default {
        background-color: rgba(255, 255, 255, 0);
    }
    .ico-buy {
        width: 46px;
        height: 37px;
    }
}
.list-panel {
    .big-list {
        padding: 59px 10px 0 10px;
    }
    .more-panel {
        height: 550px;
    }
}
</style>

